export const incidentDetailsFormRules = {
  description: [{ required: true, message: 'Report Narrative is required!' }],
  category: [{ required: true, message: 'Classification is required!' }],
  subCategory: [{ required: true, message: 'Sub-incident classification is required!' }],
};
